"use strict";
// This file contains "general-purpose" code; i.e. code that isn't specific to
// math rendering, but just happens to only be used in this package (so far).
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazy = exports.isPresentational = exports.createSpanWithRedText = exports.convertCaughtValueToError = void 0;
// convert a string or Error to an Error
function convertCaughtValueToError(e) {
    if (e instanceof Error) {
        return e;
    }
    return new Error(String(e));
}
exports.convertCaughtValueToError = convertCaughtValueToError;
function createSpanWithRedText(content) {
    const span = document.createElement("span");
    span.appendChild(document.createTextNode(content));
    span.style.color = "red";
    return span;
}
exports.createSpanWithRedText = createSpanWithRedText;
function isPresentational(element) {
    while (element) {
        if (nodeHasRoleIn(element, presentationalRoles)) {
            return true;
        }
        element = element.parentElement;
    }
    return false;
}
exports.isPresentational = isPresentational;
/**
 * List of aria-roles that apply "presentation" to descendants, which strips
 * math markup of its semantic meaning, which makes it inaccessible to screen
 * readers and other assistive technology.
 *
 * Taken from this rule from WAI-ARIA 1.2:
 * https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 */
const presentationalRoles = [
    "button",
    "checkbox",
    "img",
    "menuitemcheckbox",
    "menuitemradio",
    "meter",
    "option",
    "progressbar",
    "radio",
    "scrollbar",
    "separator",
    "slider",
    "switch",
    "tab",
    // "combobox" is NOT included in the WAI-ARIA 1.2 list of aria-roles that
    // apply "presentation" to descendants, but screenreaders seem to treat it
    // as presentational anyway. For context, see:
    // - https://github.com/Khan/mathjax-renderer/commit/d706d27eab482f32d0d1c93f23fb6af6d1add8cf
    // - https://khanacademy.atlassian.net/browse/LIT-1425
    "combobox",
];
const nodeHasRoleIn = (dom, roles) => roles.some((role) => dom.matches(`[role=${role}]`));
// lazy() wraps a zero-argument function in a cache, ensuring that expensive or
// side-effecting computations inside the wrapped function only happen once, on
// the first call to the lazy function. A separate cache is created for each
// invocation of lazy().
function lazy(f) {
    let cache;
    return () => {
        if (cache == null) {
            cache = f();
        }
        return cache;
    };
}
exports.lazy = lazy;
